import { useContext, useEffect } from "react";
import { UserStore } from "../..";
import BreadCrumbs from "../../components/breadcrumsb";
import { PageContainer } from "../../components/page";
import { runAuthHandler } from "../util";
import { useNavigate } from "react-router";
import MobileBannerCreator from "./MobileBannerCreator";

const PAGE_TITLE = "Create Mobile Banner Page";

const CreateMobileBannerPage = () => {
  const navigate = useNavigate();
  const userStore = useContext(UserStore);
  const { selectedVenue } = userStore;

  useEffect(() => {
    runAuthHandler({ userStore, navigate });
  }, [selectedVenue]);

  return (
    <PageContainer>
      <BreadCrumbs
        routes={[
          { path: "/home", breadcrumbName: "Home" },
          { path: "/mobile-banners", breadcrumbName: "Mobile Banners" },
          {
            path: "/mobile-banners/create",
            breadcrumbName: "Create Mobile Banner",
          },
        ]}
      />
      <div className="text-3xl mb-6 text-center font-bold">{PAGE_TITLE}</div>
      <div className="w-full">
        <MobileBannerCreator />
      </div>
    </PageContainer>
  );
};

export default CreateMobileBannerPage;
